export enum MODES {
  MAIN_LIST = "main-list",
  PANEL_LIST = "panel-list",
  SINGLE = "single",
  VIDEO_CREATOR = "video-creator"
}
